import React, { useState, useEffect } from 'react';
import './AboutVenueDetails.css';
import { FaLocationDot, FaPhone } from 'react-icons/fa6';
import { MdOutlineMail } from 'react-icons/md';
import axios from 'axios';
import ClubReviewModal from './ClubReviewModal';
import ReactStars from 'react-stars';
import { API_BASE_URL } from '../../utils';

export default function AboutVenueDetails({ data }) {
  const url = `${API_BASE_URL}/master/assets/uploads/`;

  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ msg: '', headline: '', image: null });

  const [ambienceRating, setAmbienceRating] = useState(0);
  const [foodRating, setFoodRating] = useState(0);
  const [hygieneRating, setHygieneRating] = useState(0);
  const [musicRating, setMusicRating] = useState(0);
  const [pricingRating, setPricingRating] = useState(0);
  const [serviceRating, setServiceRating] = useState(0);

  const [ratingData, setRatingData] = useState({});
  const [parameter, setParameter] = useState([]);
  const [reviews, setReviews] = useState([]);

  const [userdata, setUserdata] = useState(JSON.parse(localStorage.getItem('userData')));
  const [id, setId] = useState(data.id);
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  const [responseMessage, setResponseMessage] = useState('');
  const [bookData, setBookData] = useState(null);
  const [showResponse, setShowResponse] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFormData((prev) => ({ ...prev, image: file }));
  };

  const fetchReviewData = () => {
    const clubid = new FormData();
    clubid.append('club_id', data.id);

    axios
      .post(`${API_BASE_URL}/master/Api/getDataPost/clubRatings`, clubid)
      .then((response) => {
        if (response.data.msg === true) {
          setReviews([]);
          setRatingData({});
        } else {
          setReviews(response.data.data);
          setRatingData(response.data.ratingsDetails);
        }
      })
      .catch((error) => {
        console.error('Error fetching club ratings:', error);
      });
  };

  useEffect(() => {
    fetchReviewData();
  }, [data.id]);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/master/Api/getData/Parameter`).then((response) => {
      if (response.data.msg === true) {
        setParameter([]);
      } else {
        setParameter(response.data.data);
      }
    });
  }, []);

  console.log("showModal", showModal);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userdata || !userdata.id) {
      setShowLoginPopup(true);
      return;
    }

    try {
      const formDataToSend = new FormData();
      formDataToSend.append('club_id', data.id);
      formDataToSend.append('user_id', userdata.id);
      formDataToSend.append('parameter_id[]', 1);
      formDataToSend.append('parameter_id[]', 2);
      formDataToSend.append('parameter_id[]', 3);
      formDataToSend.append('parameter_id[]', 4);
      formDataToSend.append('parameter_id[]', 5);
      formDataToSend.append('parameter_id[]', 6);
      formDataToSend.append('stars[]', ambienceRating);
      formDataToSend.append('stars[]', foodRating);
      formDataToSend.append('stars[]', hygieneRating);
      formDataToSend.append('stars[]', musicRating);
      formDataToSend.append('stars[]', pricingRating);
      formDataToSend.append('stars[]', serviceRating);

      for (const field in formData) {
        formDataToSend.append(field, formData[field]);
      }

      const response = await axios.post(`${API_BASE_URL}/master/Api/sendData/submitReview`, formDataToSend,
      );



      const responseData = response.data;

      console.log(responseData.status);


      if (responseData.status) {
        setShowModal(false);
        setResponseMessage(responseData.msg);
        setBookData(responseData.data);
        fetchReviewData();
      } else {
        setResponseMessage('Error in processing the request');
      }
    } catch (error) {
      setResponseMessage('An error occurred');
    }
    finally {
      setShowModal(false);
    }
  };


  return (
    <div className="venue-about-container">
      <h1 className="venue-heading">About</h1>

      <div className="highlight-section">
        <h6>About The {data?.name}</h6>
        <p className='about-venue'> {data?.about?.description || `${data?.about?.venue_type} in ${data?.areaName}, ${data?.cityName} is a premium party destination, perfect for birthdays, weekend hangouts, and office get-togethers. It offers hassle-free table bookings, delicious food, live music, and excellent service. With a stylish setup and customized packages, every celebration feels truly special. Whether you’re planning a small gathering or a grand event, this venue provides a lively vibe and a stress-free experience. Celebrate unforgettable moments with your loved ones, friends, family, or colleagues in a vibrant, fun-filled atmosphere that turns every occasion into a lasting memory.`}</p>
      </div>
      <hr />

      <div className="highlight-section">
        <h6>Highlights</h6>
        <div className='highlight-venue-section'>
          <div className='highlight-venue-features'>
            <p>Capacity : Up to 500 guest</p>
            <p>Valet Parking Available</p>
            <p>In-house Catering & DJ</p>
          </div>
          <div className='highlight-venue-features'>
            <p>Dedicated Bridal Room</p>
            <p>Air Conditioned Banquet Halls</p>
          </div>
        </div>
      </div>
      <hr />
      <div className="highlight-section">
        <h6>Venue Features</h6>
        <div className='highlight-venue-section'>
          <div className='highlight-venue-features'>
            <p>Stage Setup</p>
            <p>Led Screens</p>
            <p>Lawn + Indoor Halls</p>
          </div>
          <div className='highlight-venue-features'>
            <p>Custom Decor</p>
            <p>Live counters</p>
          </div>
        </div>
      </div>


      <hr />
      <div className='highlight-section'>
        <div className='highlight-review-section'>
          <h6>Reviews</h6>
          <span onClick={() => setShowModal(true)}><i class="fi fi-rr-pencil"></i>Write a review</span>

        </div>
        <div className='review-highlight-section'>
          {reviews?.length > 0 ? (
            <>
              <div className='review-highlight-section-content-wrapper'>
                <div className='review-highlight-section-content'>
                  <div className='review-highlight-section-content-average'>
                    <h1>{ratingData?.averageTotal?.toFixed(2)}</h1>
                    <span>
                      <ReactStars
                        count={5}
                        size={70}
                        activeColor="#ffd700"
                        borderRadius="20px"
                        value={ratingData?.averageTotal?.toFixed(2)}
                        isHalf={true}
                        edit={false}
                      />
                    </span>
                    <p>of {ratingData?.totalRating} reviews</p>
                  </div>


                  <div className='review-highlight-section-content-stars'>
                    <div className='review-highlight-section-content-stars-average'>
                      <p>Ambience</p>
                      <ReactStars
                        count={5}
                        size={20}
                        activeColor="#ffd700"
                        value={ratingData?.averageAmbience?.toFixed(2)}
                        isHalf={true}
                        edit={false}
                      />

                    </div>

                    <div className='review-highlight-section-content-stars-average'>
                      <p>Food</p>
                      <ReactStars
                        count={5}
                        size={20}
                        activeColor="#ffd700"
                        value={ratingData?.averageFood?.toFixed(2)}
                        isHalf={true}
                        edit={false}
                      />

                    </div>

                    <div className='review-highlight-section-content-stars-average'>
                      <p>Hygiene</p>
                      <ReactStars
                        count={5}
                        size={20}
                        activeColor="#ffd700"
                        value={ratingData?.averageHygiene?.toFixed(2)}
                        isHalf={true}
                        edit={false}
                      />
                    </div>

                    <div className='review-highlight-section-content-stars-average'>
                      <p>Music</p>
                      <ReactStars
                        count={5}
                        size={20}
                        activeColor="#ffd700"
                        value={ratingData?.averageMusic?.toFixed(2)}
                        isHalf={true}
                        edit={false}
                      />


                    </div>

                    <div className='review-highlight-section-content-stars-average'>
                      <p>Pricing</p>

                      <ReactStars
                        count={5}
                        size={20}
                        activeColor="#ffd700"
                        value={ratingData?.averagePricing?.toFixed(2)}
                        isHalf={true}
                        edit={false}
                      />


                    </div>

                    <div className='review-highlight-section-content-stars-average'>
                      <p>Service</p>
                      <ReactStars
                        count={5}
                        size={20}
                        activeColor="#ffd700"
                        value={ratingData?.averageService?.toFixed(2)}
                        isHalf={true}
                        edit={false}
                      />

                    </div>
                  </div>

                </div>
              </div>

              <div className='user-review-list-section'>

                {reviews?.map((item, index) => (
                  <div className='user-review-list-section-content' key={index}>
                    <div className='user-review-list-section-content-user'>
                      <div className='user-review-list-section-content-user-img'>
                        <img src={url + item?.userDetails?.img} alt="" />
                      </div>
                      <div className='user-review-list-section-content-user-name'>
                        <h3>{item?.userDetails?.name}</h3>
                        <p>
                          {/* {item?.rating} */}
                          <ReactStars
                            count={5}
                            size={14}
                            activeColor="#ffd700"
                            value={Number(Math.max(...item?.stars.split(',').map(Number)))}
                            isHalf={true}
                            edit={false}
                          /></p>
                        <div className='user-review-list-section-content-review'>
                          <p>{item?.msg}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                ))}


              </div>
            </>
          ) : (
            <>Be the first to write a review</>
          )}
        </div>
      </div>

      {/* <Rating /> */}

      <ClubReviewModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        handleSubmit={handleSubmit}
        formData={formData}
        handleInputChange={handleInputChange}
        handleImageChange={handleImageChange}
        ambienceRating={ambienceRating}
        foodRating={foodRating}
        hygieneRating={hygieneRating}
        musicRating={musicRating}
        pricingRating={pricingRating}
        serviceRating={serviceRating}
        handleAmbienceRatingChange={setAmbienceRating}
        handleFoodRatingChange={setFoodRating}
        handleHygieneRatingChange={setHygieneRating}
        handleMusicRatingChange={setMusicRating}
        handlePriceRatingChange={setPricingRating}
        handleServiceRatingChange={setServiceRating}
      />

    </div>
  );
}
